/**
 * Prijavljeni uporabnik za ves vmesnik.
 *
 * Strani ga potrebujejo za eno samo vprasanje: ali je to admin racunovodskega
 * servisa ali stranka. Dostop do podatkov s tem ni varovan - to dela streznik
 * (CLAUDE.md, pravilo 5); tukaj gre samo za to, da stranka ne vidi gumbov,
 * ki jih ne sme uporabiti.
 */
import type { Uporabnik } from '@koda/shared';
import { createContext, useContext } from 'react';

export const UporabnikContext = createContext<Uporabnik | null>(null);

/** Prijavljeni uporabnik. Znotraj prijavljene aplikacije je vedno na voljo. */
export function useUporabnik(): Uporabnik {
  const uporabnik = useContext(UporabnikContext);
  if (!uporabnik) throw new Error('Uporabnik je na voljo samo znotraj prijavljene aplikacije.');
  return uporabnik;
}
